/* --- SVG Icon Components --- */
import { Add } from './svg/add';
import { ArrowBack } from './svg/arrowBack';
import { ArrowDown } from './svg/arrowDown';
import { ArrowLeft } from './svg/arrowLeft';
import { ArrowRight } from './svg/arrowRight';
import { Building } from './svg/building';
import { ChatIcon } from './svg/chat';
import { ChatFooterArrowRight } from './svg/chatFooterArrow';
import { CheckIcon } from './svg/checkIcon';
import { Checked } from './svg/checked';
import { CleanierLogo } from './svg/cleanierLogo';
import { ClipboardIcon } from './svg/clipboard';
import { Close } from './svg/close';
import { CloseIcon } from './svg/closeIcon';
import { DefaultUserIcon } from './svg/defaultUserIcon';
import { DownloadIcon } from './svg/downloadIcon';
import { EditIcon } from './svg/editIcon';
import { Ellipsis } from './svg/ellipsis';
import { Emoticon } from './svg/emoticon';
import { FileCloseIcon } from './svg/fileCloseIcon';
import { Info } from './svg/info';
import { InfoTriangle } from './svg/infoTriangle';
import { Logo } from './svg/logo';
import { MegaPhoneIcon } from './svg/megaphone';
import { Members } from './svg/members';
import { Mention } from './svg/mention';
import { PdfIcon } from './svg/pdfIcon';
import { Person } from './svg/person';
import { PlusIcon } from './svg/plusIcon';
import { SixDots } from './svg/sixDots';
import { SubtractIcon } from './svg/subtractIcon';
import { Tasks } from './svg/tasks';
import { Upload } from './svg/upload';
import { UserIcon } from './svg/user';

const SvgIcon = (props) => {
  switch (props.name) {
    case 'cleanierLogo':
      return <CleanierLogo {...props} />;
    case 'chatArrowRightIcon':
      return <ChatFooterArrowRight {...props} />;
    case 'checkIcon':
      return <CheckIcon {...props} />;
    case 'closeIcon':
      return <CloseIcon {...props} />;
    case 'defaultUserIcon':
      return <DefaultUserIcon {...props} />;
    case 'downloadIcon':
      return <DownloadIcon {...props} />;
    case 'editIcon':
      return <EditIcon {...props} />;
    case 'fileCloseIcon':
      return <FileCloseIcon {...props} />;
    case 'pdfIcon':
      return <PdfIcon {...props} />;
    case 'plusIcon':
      return <PlusIcon {...props} />;
    case 'subtractIcon':
      return <SubtractIcon {...props} />;
    case 'upload':
      return <Upload {...props} />;
    case 'mention':
      return <Mention {...props} />;
    case 'emoticon':
      return <Emoticon {...props} />;
    case 'add':
      return <Add {...props} />;
    case 'logo':
      return <Logo {...props} />;
    case 'checked':
      return <Checked {...props} />;
    case 'tasks':
      return <Tasks {...props} />;
    case 'members':
      return <Members {...props} />;
    case 'info':
      return <Info {...props} />;
    case 'InfoTriangle':
      return <InfoTriangle {...props} />;
    case 'building':
      return <Building {...props} />;
    case 'person':
      return <Person {...props} />;
    case 'arrowDown':
      return <ArrowDown {...props} />;
    case 'arrowBack':
      return <ArrowBack {...props} />;
    case 'arrowLeft':
      return <ArrowLeft {...props} />;
    case 'arrowRight':
      return <ArrowRight {...props} />;
    case 'sixDots':
      return <SixDots {...props} />;
    case 'ellipsis':
      return <Ellipsis {...props} />;
    case 'close':
      return <Close {...props} />;
    case 'clipboard':
      return <ClipboardIcon {...props} />;
    case 'chat':
      return <ChatIcon {...props} />;
    case 'megaphone':
      return <MegaPhoneIcon {...props} />;
    case 'user':
      return <UserIcon {...props} />;
    default:
      return <div />;
  }
};

export default SvgIcon;
